// The level, one per account. READONLY carries USER for reads and is blocked
// on every write server-side. AGENT is an external agency account: it
// carries no USER authority, so it sees none of the staff app — only the
// agent portal, once that exists. Admin-and-agent is unrepresentable by
// design; someone wearing both hats gets two accounts.
export const ROLE_OPTIONS = ["USER", "ADMIN", "READONLY", "AGENT"];

// Capabilities on top of the level, zero or more per account. PUT
// /api/admin/users/{id}/grants takes the complete set. ADMIN passes all of
// them already, so a grant on an admin changes nothing.
//
// AGENT is deliberately not here: it narrows an account rather than
// widening it, so it is a level (ROLE_OPTIONS), not a grant.
export const GRANT_OPTIONS = [
  { key: "FINANCE", label: "Finance", hint: "Invoices, balances, payments, commission, rent, quotes" },
  { key: "TRANSPORT", label: "Transport", hint: "Edit and confirm transport groups; bus assignment" },
  { key: "SUPERVISOR", label: "Supervisor", hint: "See and approve the hours and overtime of their people" },
];
export const POLL_MS = 10000;

export const ADMIN_TABS = {
  USERS: 0,
  SUPERVISION: 1,
  CAMPUSES: 2,
  AUDIT: 3,
  HUBSPOT: 4,
  SETTINGS: 5,
};

// Product types the HubSpot mapping can restrict a SKU to (comma-joined on save).
export const HUBSPOT_PRODUCT_TYPES = [
  "RESIDENTIAL",
  "AFTERNOON",
  "WEEKEND",
  "EXTERNAL",
  "EXTRA",
  "EVENT",
];